import Vue from 'ninenine-white-label/Vue';
import Router from 'vue-router';
import store from './store';
import Home from '@/views/Home';
import HomeEs from '@/views/HomeEs';
import Profile from './views/Profile.vue';
import ProfileEs from './views/ProfileEs.vue';
import Subscription from './views/Subscription/Subscription.vue';
import SubscriptionForm from './views/Subscription/SubscriptionForm.vue';
import SubscriptionFormEs from './views/Subscription/SubscriptionFormEs.vue';
import Job from '@/views/Job';
import JobEs from '@/views/JobEs';
import Tests from './views/Subscription/Tests.vue';
import PendingTests from './views/Subscription/PendingTests.vue';
import OnlineTest from './views/Subscription/OnlineTest.vue';
import CoverTest from './views/Subscription/CoverTest.vue';
import SubscriptionSuccessReturn from './views/Subscription/SubscriptionSuccessReturn.vue';
import SubscriptionSuccessReturnEs from './views/Subscription/SubscriptionSuccessReturnEs.vue';
import SubscriptionErrorReturn from './views/Subscription/SubscriptionErrorReturn.vue';
import RegisterProfile from './views/RegisterProfile.vue'
import NotFound from './views/404.vue'
import AcceptHunting from './views/AcceptHunting.vue'
import EliminatedByQuestions from './views/EliminatedByQuestions.vue'

Vue.use(Router);

const router = new Router({
  mode: 'history',

  base: process.env.BASE_URL,

  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: {
          y: 120
        }
      }
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  },

  routes: [
    {
      path: '/es/vagas/*',
      name: 'home',
      beforeEnter: (to, from, next) => {
        localStorage.setItem('lang', 'es')
        const path = to.path.replace('/es', '')
        next(path);
      }
    },

    {
      path: '/',
      name: 'home',
      component: localStorage.getItem('lang') == 'pt' ? Home : HomeEs,
    },

    {
      path: '/password-recovery',
      name: 'password-recovery',
      component: Home,
      beforeEnter: (to, from, next) => {
        store.commit('DEVISE_FORM', 'change-password');
        next()
      }
    },

    {
      path: '/InsertCpf',
      name: 'insert-cpf',
      component: Home,
      beforeEnter: (to, from, next) => {
        store.commit('DEVISE_FORM', 'insert-cpf');
        next()
      }
    },

    {
      path: '/vagas/:id',
      name: 'job',
      component: localStorage.getItem('lang') == 'pt' ? Job : JobEs
    },

    {
      path: '/vagas/:id/inscricao',
      name: 'job',
      component: Subscription,
      meta: { requiresAuth: true },
      beforeEnter: (to, from, next) => {
        if(to.fullPath.indexOf('375953') !== -1){
          localStorage.setItem('lang', 'es')
        }

        next();
      },
      children: [
        {
          path: '',
          name: 'ficha',
          component: localStorage.getItem('lang') == 'pt' ? SubscriptionForm : SubscriptionFormEs,
          meta: { requiresAuth: true }
        },

        {
          path: 'testes',
          name: 'testes',
          component: Tests,
          meta: { requiresAuth: true }
        },

        {
          path: 'testes-pendentes',
          name: 'pending-tests',
          component: PendingTests,
          meta: { requiresAuth: true },
        },

        {
          path: ':testName/:testId',
          name: 'capa-teste',
          component: CoverTest,
          meta: { requiresAuth: true }
        },

        {
          path: ':headerTestId/teste/:first_question',
          name: 'teste',
          component: OnlineTest,
          meta: { requiresAuth: true }
        },
      ]
    },

    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }

    {
      path: '/deixe-seu-perfil',
      name: 'deixe-seu-perfil',
      component: RegisterProfile,
      meta: { requiresAuth: true },
    },

    {
      path: '/accept_hunting/:token',
      name: 'accept_hunting',
      component: AcceptHunting,
    },

    {
      path: '/meu-perfil',
      name: 'meu-perfil',
      component: localStorage.getItem('lang') == 'pt' ? Profile : ProfileEs,
      meta: { requiresAuth: true }
    },

    {
      path: '/inscricao-recusada',
      name: 'inscricao-recusada',
      component: EliminatedByQuestions,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/erro-inscricao',
      name: 'erro-inscricao',
      component: SubscriptionErrorReturn,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/inscricao-confirmada',
      name: 'inscricao-confirmada',
      component: localStorage.getItem('lang') == 'pt' ? SubscriptionSuccessReturn : SubscriptionSuccessReturnEs,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/linkedin-return',
      name: 'linkedin-return',
      beforeEnter: (to, from, next) => {
        const url_string = window.location.href
        const url = new URL(url_string);
        const code = url.searchParams.get("code");
        const error = url.searchParams.get("error");

        if(to.query.back_to){
          localStorage.setItem('back_to', to.query.back_to)
        }

        if(code || error){
          if(localStorage.getItem('back_to')){
            let params = window.location.search
            if(params.indexOf('?code=') !== -1){
              params = params.replace('?code=', '&code=')
            }
            next(localStorage.getItem('back_to') + params)
          }
        }else{
          const return_url = window.location.origin + '/linkedin-return'
          window.location.href = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${Vue.prototype.socialIds.linkedin}&redirect_uri=${ return_url }&scope=r_liteprofile%20r_emailaddress`
        }

      }
    },

    {
      path: '*',
      name: 'not-found',
      component: NotFound
    }

  ]
});

router.beforeEach((to, from, next) => {
  store.commit('DEVISE_FORM', null);

  if(from.name == null){
    localStorage.removeItem('allFilters')
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if(store.state.pendingAcceptTerms == true){
      Vue.prototype.$EventBus.$emit('showTermsOfUse');
    }

    if (!Vue.prototype.$session.exists()) {
      let {
        path,
        query
      } = from;
      next({
        path: path,
        query: query
      })

      if(store.state.deviseClosedToReadTerms.first_name){
        store.commit('DEVISE_FORM', 'register');
      }else{
        store.commit('DEVISE_FORM', 'login');
      }

      store.commit('user/SET_NEXT_ROUTE', to);
    } else {
      next()
      store.commit('user/SET_NEXT_ROUTE', null);
    }
  } else {
    next();
  }
});

export default router;
